<nav class="navbar fixed-top">
  <div class="d-flex align-items-center navbar-left">
    <a (click)="menuButtonClick($event, sidebar.menuClickCount, sidebar.containerClassnames); false;" href="javascript:;"
       class="no-print menu-button d-none d-md-block" data-test="menu-button">
      <div *ngIf="showSidebarMenuBurger">
        <span class="main"><i class="fas fa-bars fa-2x"></i></span>
      </div>
    </a>

    <a *ngIf="!hideSettingsMenu" (click)="mobileMenuButtonClick($event, sidebar.containerClassnames)" href="javascript:;"
       class="no-print menu-button-mobile d-xs-block d-sm-block d-md-none" data-test="menu-button-mobile">
      <span class="main"><i class="fas fa-bars fa-2x"></i></span>
    </a>

    <a class="navbar-logo" [routerLink]="adminRoot+'/profile/create'" [class.navbar-logo_disabled]="hideSettingsMenu">
      <span class="logo d-none d-xs-block ml-3"></span>
      <span class="logo-mobile d-block d-xs-none ml-3"></span>
    </a>
  </div>

  <div class="navbar-right no-print" *ngIf="!hideSettingsMenu">
    <div class="navbar-right__cog-wrapper cog-wrapper d-inline-block" dropdown>
      <button class="cog-wrapper__btn btn btn-empty p-0" type="button" (click)="onCogClick()" data-test="setting-menu">
        <!-- <u>{{ userName$ | async }}</u> -->
        <i #toggleButton class="fas fa-cog cog-icon"></i>
      </button>
      <div #menu class="dropdown-menu dropdown-menu-right cog-wrapper__setting-dropdown setting-dropdown" role="menu"
           (mouseleave)='isSettingsOpened = false' [class.hide]="!isSettingsOpened">
        <div class="setting-dropdown__user-name">{{ userName$ | async }}</div>
        <a class="dropdown-item c-pointer" href="#" [routerLink]="['profile/create']" [translate]="'setting-menu.profiles'"
           data-test="menu-profiles"></a>
        <a class="dropdown-item c-pointer" (click)="saveRedirectUrl()" [routerLink]="['settings']" [translate]="'setting-menu.settings'"
           data-test="menu-settings"></a>
        <li class="divider dropdown-divider setting-dropdown__divider"></li>
        <a class="dropdown-item c-pointer setting-dropdown__sign-out" href="#" (click)="onSignOut($event)" [translate]="'setting-menu.sign-out'"
           data-test="menu-logout"></a>
      </div>
    </div>

  </div>
</nav>
